export default __webpack_public_path__ + "static/media/Aura-Egg__61.4b57724b.png";